var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cmpt-search"},[_c('div',{staticClass:"search-quickly"},[_vm._m(0),_c('div',{staticClass:"content"},_vm._l((_vm.data),function(item,index){return _c('div',{key:index,staticClass:"search-item",on:{"click":function($event){return _vm.$emit('search', item)}}},[_vm._v(" "+_vm._s(item)+" ")])}),0)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title"},[_c('span',[_vm._v("快速搜索")])])
}]

export { render, staticRenderFns }